/**
 * @description TOPページのロゴ画像がキャッシュされるとanimが動作しないため
 */

export const setOpeningLogo = () => {
  const target = $('.js-opening-logo').find('img').attr('src');
  if (!target?.length) return;

  $('.js-opening-logo').find('img').attr('src', `${target}?${new Date().getTime()}`);
};
